import dayjs, {type Dayjs} from "dayjs";
import {renderer} from "../../../util/renderer";
import {type BillingGranularity} from "../AdminTypes";

export type BillingMetricKey = "tokens" | "price";

export function formatIsoDate(dateValue: Date) {
    const year = dateValue.getFullYear();
    const month = String(dateValue.getMonth() + 1).padStart(2, "0");
    const day = String(dateValue.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
}

export function getInitialDateRange() {
    const today = new Date();

    return {
        startDate: formatIsoDate(new Date(today.getFullYear() - 1, today.getMonth(), 1)),
        endDate: formatIsoDate(today),
    };
}

export function toDayjs(value: string) {
    if (!value) {
        return null;
    }

    const parsedValue = dayjs(value);
    return parsedValue.isValid() ? parsedValue : null;
}

export function toIsoDate(value: Dayjs | null) {
    if (!value || !value.isValid()) {
        return "";
    }

    return value.format("YYYY-MM-DD");
}

export function formatDateLabel(value: string, options: Intl.DateTimeFormatOptions) {
    const parsedValue = dayjs(value);

    if (!parsedValue.isValid()) {
        return "-";
    }

    return renderer.formatLocalizedDate(parsedValue.format("YYYY-MM-DD"), options);
}

export function formatMetricValue(metric: BillingMetricKey, value: number) {
    if (metric === "price") {
        return renderer.formatCurrency(value);
    }

    return renderer.formatNumber(value);
}

export function formatBucketLabel(dateValue: string, granularity: BillingGranularity) {
    switch (granularity) {
        case "MONTHLY":
            return renderer.formatLocalizedDate(dateValue, {month: "short", year: "numeric"});
        case "YEARLY":
            return renderer.formatLocalizedDate(dateValue, {year: "numeric"});
        default:
            return renderer.formatShortDate(dateValue);
    }
}

export function formatPriceDraft(value?: number | null) {
    return value === null || value === undefined ? "" : String(value);
}

export function parsePriceDraft(value: string) {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
        return null;
    }

    const parsedValue = Number(trimmedValue);
    return Number.isFinite(parsedValue) ? parsedValue : null;
}
